export default __webpack_public_path__ + "static/media/info.b21a6c8b.svg";